import React, { useEffect, useState } from "react";
import Paytm from "./component";
import { connect } from "react-redux";
import {  toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const PaytmContainer=(props)=>{
  const { makeApiRequest } = useApiRequest()
const navigate = useNavigate();
const[mobile,setMobile]=useState("")
const[Otp,setOtp]=useState("")
const [mobileFlag,setMoblieFlag]=useState(true)
const [isExistingPaytmUser,setIsExistingPaytmUser]=useState("")
const [paytmState,setPaytmState]=useState("")
const [loader,setLoader]=useState(false)
const [remainingTime, setRemainingTime] = useState(10);
const [isDisabled, setIsDisabled] = useState(true);

const [showTimer, setShowTimer] = useState(false);
  const [timer, setTimer] = useState(30);

useEffect(()=>{
  
  SubmitMobile()
  
},[])

useEffect(() => {
  let interval;
  
  if (showTimer && timer > 0) {
    interval = setInterval(() => {
      setTimer(prevTimer => prevTimer - 1);
    }, 1000);
  }

  return () => {
    clearInterval(interval);
  };
}, [showTimer, timer]);




const UserJWTAuth = localStorage.getItem('UserJWTAuth');
useEffect(()=>{
 
 //logger.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
 if(!UserJWTAuth){
   navigate('/')
 }
},[])

useEffect(() => {
   
    
  t()
  //logger.log("isDisable",isDisabled)
  
 
  
    }, [isDisabled]);
const timmer=()=>{

  setRemainingTime(prevTime => prevTime - 1);
 
  //logger.log("remainingTime>=0",remainingTime)
  
}


  
  
  
  const t=()=>{
    let interval;
    if (isDisabled ) {
      interval = setInterval(() => {
       
      timmer()
      }, 1000); // Update the remaining time every second
    }
  
    return () => {
      clearInterval(interval);
    };
  }  
  
let onchangeMobile=(e)=>{
  
    setMobile(e.target.value)
//logger.log("mobile",e.target.value,mobile)

}


let onchangeOtp=(e)=>{

    setOtp(e.target.value)
//logger.log("mobile",e.target.value)

}


const handleSendOTP = () => {

    

  SubmitMobile()

 
  t()

  setTimeout(() => {
    setIsDisabled(true);

  }, 60000);

};



const SubmitMobile = () => {
  setTimeout(() => {
    setIsDisabled(true);

  }, 60000);


    const UserJWTAuth = localStorage.getItem('UserJWTAuth');
    const activeOrderId = localStorage.getItem('activeOrderId');
    //logger.log("UserJWTAuth",UserJWTAuth)
    setLoader(true)
   // logger.log("inventory...container")




  makeApiRequest({
    url: `${process.env.REACT_APP_API_BASE_URL}/payment/link/paytm/wallet`,
     method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
    },
    data:{       
  "mobileNo": null

      },
     handleSuccess: (res) => handleResponsePaytmAuth(res),
         handleError: (res) => handleErrorPaytmAuth
  });


};

const handleErrorPaytmAuth=(err)=>{

  setLoader(false)
       
  //logger.log("Get response pickupApi",err&&err.response&&err.response.data.statusMessage);
  toast.error(`${err&&err.response&&err.response.data.statusMessage}`, {
    position: "top-right",
    autoClose: 1000,
});
}

const handleResponsePaytmAuth=(response)=>{
        //logger.log("Get response paytm Link",response&&response.data.statusCode);
        //setIsDisabled(false)
        setIsDisabled(true);
        setRemainingTime(60);
        if(response.data.status=="SUCCESS"){
            setIsExistingPaytmUser(response&&response.data.response&&response.data.response.isExistingPaytmUser)
            setPaytmState(response&&response.data.response&&response.data.response.state)
            

        }
        if(response&&response.data&&response.data.statusCode){
         // navigate('/paymentOption')
         //setMoblieFlag(false)

        }
        
        setLoader(false)
        if(response.data.status=="FAILURE"){
          //setIsDisabled(false)
        toast.error(`${response&&response.data.statusMessage}`, {
            position: "top-right",
            autoClose: 1000,
        });
    }
      
}



const Verfy = () => {
 
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  //logger.log("UserJWTAuth",UserJWTAuth)
  setLoader(true)
  //logger.log("inventory...container")


  makeApiRequest({
    url: `${process.env.REACT_APP_API_BASE_URL}/payment/validate/paytm/otp`,
     method: "POST",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
    },
    data:{       
      "request": {
        "state":paytmState,
        "mobileNo": null,
        "otp": Otp
        
        }

      },
     handleSuccess: (res) => handleResponseVerifyPaytmOtp(res),
         handleError: (res) => handleErrorVerifyPaytmOtp
  });



};


const handleErrorVerifyPaytmOtp=(err)=>{
  setLoader(false)
       
  //logger.log("Get response pickupApi",err&&err.response&&err.response.data.statusMessage);
  toast.error(`${err&&err.response&&err.response.data.statusMessage}`, {
    position: "top-right",
    autoClose: 1000,
});
}
const handleResponseVerifyPaytmOtp=(response)=>{
//logger.log("Get response paytm Link",response);
  //setIsDisabled(true)
 
  if(response.data.status=="SUCCESS"){
      setIsExistingPaytmUser(response&&response.data.response&&response.data.response.isExistingPaytmUser)
      setPaytmState(response&&response.data.response&&response.data.response.state)
      navigate('/paymentOption')
      //setMoblieFlag(false)

  }
  
  setLoader(false)
  
  if(response.data.status=="FAILURE"){
    
  toast.error(`${response&&response.data.statusMessage}`, {
      position: "top-right",
      autoClose: 1000,
      
  });
}
}



    return(<>
    
    <Paytm 
    onchangeMobile={onchangeMobile}
    mobileFlag={mobileFlag}
    mobile={mobile}
    SubmitMobile={SubmitMobile}
    onchangeOtp={onchangeOtp}
    Otp={Otp}
    Verfy={Verfy}
    remainingTime={remainingTime}
    isDisabled={isDisabled}
    handleSendOTP={handleSendOTP}
    
   
    />
    </>)
}

  export default PaytmContainer